<template>
    <div class="index-1-left-1" @click="clickIndex()">
        <div>
            <div class="index-title" style="display: flex;">
                <img src="/img/home/fysj.png" alt="" style="width: 20px;height: 20px;margin-right: 5px;">
                <span>费用数据</span>
            </div>
        </div>
        <el-row :gutter="20" style="padding: 10px" type="flex" justify="space-between">
            <el-col :span="5" v-for="(l,i) in list" :key="i">
                <div
                    style="display: grid;border: 1px solid rgba(0, 0, 0, 0.1);border-radius: 8px;padding: 25px 15px 20px 15px;">
                    <div style="display: flex;font-size: 12px;align-items: center;">
                        <img :src="l.src" alt="" style="width: 12px;height: 12px;">
                        <div style="margin-left: 2px;color: #000;font-size: 13px;">{{ l.label }}</div>
                    </div>
                    <div style="display: flex;align-items: center;margin-top: 2px;">
                        <div style="color: rgba(250, 95, 71, 1);font-size: 28px;font-weight: 700;">
                            {{ showMoney(i) }}
                        </div>
                        <span style="font-size: 12px;padding-top: 5px;">元</span>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import {getPropertyAssetsIndex} from '@/api/index/propertyIndexApi'

export default {
    name: 'IndexCommunity',
    data() {
        return {
            list: [{
                'label': '房租',
                'money': '1123',
                'src': "/img/home/tab_ic.png",
            }, {
                'label': '水电费',
                'money': '245',
                'src': "/img/home/tab_ic.png",
            }, {
                'label': '物业费',
                'money': '3789',
                'src': "/img/home/tab_ic.png",
            }, {
                'label': '暖气费',
                'money': '46666',
                'src': "/img/home/nqf.png",
            }, {
                'label': '押金',
                'money': '46666',
                'src': "/img/home/yajin.png",
            }],
            indexCommunityViewInfo: {
                floorCount: 0,
                roomCount: 0,
                shopCount: 0,
                ownerCount: 0,
                spaceCount: 0,
                carCount: 0,
                revenueData: {
                    month: 0,
                    nuanqifei: 0,
                    shuidianfei: 0,
                    today: 0,
                    wuyefei: 0,
                    yajin: 0,
                    year: 0,
                    yesterday: 0,
                    zujin: 0,
                },
            },
            stats: [
                {key: 'floorCount', label: 'building', icon: 'el-icon-office-building'},
                {key: 'roomCount', label: 'house', icon: 'el-icon-house'},
                {key: 'shopCount', label: 'shop', icon: 'el-icon-shopping-bag-2'},
                {key: 'spaceCount', label: 'parkingSpace', icon: 'el-icon-truck'}
            ]
        }
    },
    created() {
    },
    filters: {
        thousandSeparator(value) {
            if (!value) return '0'
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
    },
    methods: {
        showMoney(i) {
            if (i === 0) {
                return this.indexCommunityViewInfo.revenueData.zujin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            } else if (i === 1) {
                return this.indexCommunityViewInfo.revenueData.shuidianfei.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            } else if (i === 2) {
                return this.indexCommunityViewInfo.revenueData.wuyefei.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            } else if (i === 3) {
                return this.indexCommunityViewInfo.revenueData.nuanqifei.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            } else {
                return this.indexCommunityViewInfo.revenueData.yajin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
        },
        clickIndex() {
            this.$router.push('/pages/property/reportFeeDetail')
        },
        _loadPropertyIndexAssets() {
            const param = {
                page: 1,
                row: 10,
                communityId: this.getCommunityId()
            }

            getPropertyAssetsIndex(param)
                .then(res => {
                    if (res.code === 0) {
                        Object.assign(this.indexCommunityViewInfo, res.data)
                    }
                })
                .catch(err => {
                    console.error('请求失败处理', err)
                })
        },
        _toOwner() {
            this.$router.push('/pages/property/listOwner?tab=ownerInfo')
        },
        _toCar() {
            this.$router.push('/pages/property/listOwnerCar?tab=ownerCar')
        }
    }
}
</script>

<style lang="scss" scoped>

.index-1-left-1 {
    border: 1px solid rgba(179, 186, 222, 1);
    background: linear-gradient(180.00deg, rgba(255, 228, 224, 1) 0%, rgba(255, 250, 250, 1) 50%);
    border-radius: 10px;
    padding: 15px;


    .index-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 15px;
        text-align: left;
        color: #333;
    }

    .index-1-left-1-content {
        padding: 50px 0;
        border-bottom: 1px solid #eee;

        > div {
            width: 25%;
            text-align: center;
        }

        .index-1-left-img {
            width: 40px;
            height: 40px;
            background: #f0f7ff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;

            i {
                font-size: 20px;
                color: #409EFF;
            }
        }

        .index-number {
            font-size: 24px;
            font-weight: bold;
            color: #333;
        }

        .index-number-describe {
            font-size: 12px;
            color: #999;
        }
    }

    .index-1-left-1-bottom {
        padding: 28px 40px;

        .index-1-left-1-bottom-item {
            width: 40%;
            border-radius: 4px;
            padding: 10px;
            padding-left: 30px;
            padding-right: 30px;

            .index-name {
                font-size: 16px;
                font-weight: bold;
                color: #333;
            }

            .index-name-ico {
                width: 40px;
                height: 40px;
                background: #e6f7ff;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 10px auto;

                i {
                    font-size: 20px;
                    color: #1890ff;
                }
            }

            .index-number {
                font-size: 24px;
                font-weight: bold;
                color: #333;

                .index-number-unit {
                    font-size: 14px;
                    color: #999;
                }
            }

            .index-number-describe {
                font-size: 12px;
                color: #1890ff;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }

    .margin-top-sm {
        margin-top: 5px;
    }
}
</style>
